exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._1Pfa4 {\n  text-align: center;\n  background: #404242;\n  padding-top: 20px;\n  padding-bottom: 20px;\n  width: 160px;\n  position: relative;\n}\n._1Pfa4.Ak7eJ {\n  background: #272828;\n}\n._1Pfa4 ._2-21l {\n  padding: 10px 10px 20px;\n}\n._1Pfa4 .RBi5J {\n  width: 100%;\n  text-align: center;\n  color: #fff;\n  background-color: #bd9471;\n  font-weight: bold;\n  font-size: 36px;\n  line-height: 1.75;\n  margin-bottom: 10px;\n  font-family: \"Cormorant Garamond\", \"Noto Serif\", \"Georgia\", \"Times\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n}\n", ""]);

// Exports
exports.locals = {
	"menuBar": "_1Pfa4",
	"uat": "Ak7eJ",
	"logo": "_2-21l",
	"uatLabel": "RBi5J"
};